import RoadMapMain from "../../components/roadMap/roadMapMain"

const RoadMap = ({authUser}) => {
  return (
    <RoadMapMain authUser={authUser} />
  )
}

export default RoadMap